export default {
  latest_privacy_policy: {}
  // latest_privacy_policy_to_accept: {}
};
